<template>
  <div>
    <div class="row">
      <div class="form-group col-lg-12">
        <label for="client">{{ $t('client') }}</label>
        <Combobox
          class="bg-white"
          name='client'
          :placeholder="$t('select_a_item')"
          label="CLI_DSC"
          :getOptionLabel="client => client.CLI_ID + ' - ' + client.CLI_DSC"
          :options="clients"
          v-model="clientSelected"
          :initial-value="clientSelected"
          :reduce="client => client.CLI_ID"
          :hasErrors="errors.has('client')"
        />

        <small v-show="errors.has('client')" class="form-text">
          {{ errors.first('client') }}
        </small>
      </div>

      <div class="form-group col-lg-4">
        <label for="date_to_filter">{{ $t('date_to_filter') }}</label>
        <Combobox
          class="bg-white"
          name='date_to_filter'
          :placeholder="$t('select_a_item')"
          label="text"
          :options="datesToFilter"
          v-model="dateToFilter"
          :initial-value="dateToFilter"
          :reduce="item => item.property"
        />
      </div>

      <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('period_start') }">
        <label for="period_start">{{ $t('period_start') }}</label>
        <input
          type="date"
          id="period_start"
          name="period_start"
          class="form-control"
          :placeholder="$t('ph_period_start')"
          v-model="periodStart"
        />
      </div>

      <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('period_end') }">
        <label for="period_end">{{ $t('period_end') }}</label>
        <input
          type="date"
          id="period_end"
          name="period_end"
          class="form-control"
          :placeholder="$t('ph_period_end')"
          v-model="periodEnd"
        />
      </div>
    </div>

    <b-form-group
      label="Tipo do relatório"
      v-slot="{ ariaDescribedby }"
    >
      <b-form-radio-group
        id="radio-group-report-type"
        v-model="reportType"
        :aria-describedby="ariaDescribedby"
        name="radio-sub-component"
      >
        <div class="col">
          <b-form-radio value="1" aria-checked>ANALÍTICO</b-form-radio>
        </div>

        <div class="col">
          <b-form-radio value="2">SINTÉTICO</b-form-radio>
        </div>

        <div class="col">
          <b-form-radio value="4">SINTÉTICO - TODOS OS MESES</b-form-radio>
        </div>

        <div class="col">
          <b-form-radio value="3">ANALÍTICO + SINTÉTICO</b-form-radio>
        </div>
      </b-form-radio-group>
    </b-form-group>

    <div class="row ml-1">
      <LoaderButton
        @click="() => print('PDF')"
      >
        Gerar PDF
        <i class="fas fa-file-pdf fa-lg ml-2" />
      </LoaderButton>

      <LoaderButton
        @click="() => print('CSV')"
        class="ml-3"
      >
        Gerar CSV
        <i class="fas fa-file-csv fa-lg ml-2" />
      </LoaderButton>
    </div>
  </div>
</template>

<script>
import LoaderButton from '@/components/button/LoaderButton'
import Combobox from '@/components/shared/ComboBox'
import { request } from '@/lib/http'
import { apiBaseUrl, baseUrlReports } from '@/lib/config'
import axios from 'axios'
import { serviceById } from '@/config/services'
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  name: 'AmountServiceByClient',

  components: {
    LoaderButton,
    Combobox
  },

  data () {
    return {
      currentPage: 1,
      perPage: 25,
      clientSelected: undefined,
      periodStart: '',
      periodEnd: '',
      services: [],
      mapServiceById: serviceById,
      reportType: 1,
      datesToFilter: [
        { text: 'Data de Criação', property: 'createdAt' },
        { text: 'Data do Serviço', property: 'testDate' }
      ],
      dateToFilter: 'createdAt'
    }
  },

  computed: {
    ...mapState({
      clients: state => state.arena.clients
    }),

    rows() {
      return this.services.length
    }
  },

  methods: {
    async print(type) {
      try {
        this.loading(true)

        let mapParams = {
          client: this.clientSelected,
          start: this.periodStart,
          end: this.periodEnd,
          type: this.reportType
        }

        if (this.periodStart || this.periodEnd) {
          mapParams.dateToFilter = this.dateToFilter || 'createdAt'
        }

        const params = []

        Object.entries(mapParams).forEach(([key, value]) => value && params.push(`${key}=${value}`))

        const urlRequest = `${apiBaseUrl()}services/print/csv`
        const client = this.clientSelected
          ? this.clients.find(client => client.CLI_ID == this.clientSelected)
          : undefined
        const clientName = client
          ? `${client.CLI_ID} - ${client.CLI_DSC}`
          : ''

        if (type === 'CSV') {
          const data = await axios.get(`${urlRequest}?${params.join('&')}`, { responseType: 'blob' })

          const url = window.URL.createObjectURL(new Blob([data.data], { type: 'text/csv; charset=latin1' }))
          const link = document.createElement('a')
          link.href  = url
          link.setAttribute('download', `${clientName || 'serviço_por_cliente'}.csv`)
          document.body.appendChild(link)
          link.click()
        }

        if (type === 'PDF') {
          const data = await request({
          method: 'get',
          url: `services/print/pdf`,
          params: mapParams
        })

        axios({
          url: baseUrlReports(),
          method: 'post',
          data: data,
          responseType: 'blob'
        })
          .then(response => {
            const file = new Blob(
              [response.data],
              { type: 'application/pdf' }
            )
            const fileURL = URL.createObjectURL(file)
            window.open(fileURL, "_blank")
          })
            .catch(error => console.log('[ERROR-PRINT-PDF] => ', error))
        }
      } catch (error) {
        console.log('[ERROR-PRINT] => ', error)
      } finally {
        this.loading(false)
      }
    },

    loading(show) {
      this.$store.dispatch('overlay/show', show)
    },

    formatDate(date) {
      return moment(date).format('DD/MM/YYYY HH:mm:ss')
    }
  },

  async mounted () {
    await this.$store.dispatch('arena/fetchClients')

    $('#print_service_by_client').on('click', async function() {
      $('#modalSelectTypeToPrint').modal('show')
    })
  },
}
</script>
